var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.545 118.458h410.91c4.422 0 7.994 3.572 7.994 7.994v377.546c0 4.422-3.571 7.994-7.994 7.994h-410.91c-4.422 0-7.994-3.572-7.994-7.994v-377.546c0-4.422 3.572-7.994 7.994-7.994z",
    fill: "#f7a603"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.599 247.378h114.803v264.614h-114.803z",
    fill: "#cc3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.599 247.378h114.803v43.2h-114.803z",
    fill: "#bf1b1b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.824 99.041c-46.346-.765-50.825 44.532-51.108 47.65-.142 3.062-2.069 5.896-5.131 7.058-4.11 1.587-8.731-.51-10.318-4.62-5.499-14.429-7.483-36.085-5.471-58.252 1.672-18.255 6.038-37.021 13.379-52.583 7.795-16.498 18.964-29.565 33.931-35.263 6.52-2.466 13.663-3.515 21.515-2.807 42.406 3.855 101.962 78.18 106.299 83.65 1.219 1.417 1.956 3.26 1.956 5.272v16.328c0 .822-.142 1.644-.396 2.438-1.333 4.195-5.839 6.52-10.035 5.159-.114-.027-40.309-13.123-94.621-14.03z",
    fill: "#e03f3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.285 146.691c-.284-3.118-4.791-48.416-51.109-47.65-54.312.907-94.507 14.003-94.62 14.032-4.195 1.36-8.703-.964-10.035-5.159-.255-.794-.397-1.616-.397-2.438h-.028v-16.328c0-2.012.765-3.855 1.984-5.272 4.337-5.471 63.893-79.795 106.299-83.65 7.852-.708 14.995.34 21.515 2.807 14.967 5.698 26.136 18.765 33.931 35.263 7.342 15.563 11.707 34.328 13.38 52.583 2.012 22.167 0 43.823-5.471 58.252-1.587 4.11-6.208 6.208-10.318 4.62-3.062-1.164-4.989-3.998-5.131-7.06z",
    fill: "#e03f3f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 69.136c16.384 0 31.238 6.661 41.981 17.405 10.743 10.743 17.376 25.568 17.376 41.953 0 16.413-6.633 31.238-17.376 41.981-10.744 10.743-25.597 17.405-41.981 17.405s-31.238-6.662-41.981-17.405-17.376-25.568-17.376-41.981c0-16.384 6.633-31.209 17.376-41.953s25.597-17.405 41.981-17.405z",
    fill: "#cc3232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m16.132 118.458h479.735c4.422 0 7.994 3.572 7.994 7.994v112.932c0 4.422-3.571 7.994-7.994 7.994h-479.735c-4.422 0-7.994-3.571-7.994-7.994v-112.932c.001-4.422 3.572-7.994 7.994-7.994z",
    fill: "#ffb703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.29 118.458h159.42v128.919h-159.42z",
    fill: "#e03f3f"
  }), /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#bf1b1b",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m197.493 118.458c.936-5.528 2.636-10.8 4.989-15.676-13.578-1.956-29.395-3.458-46.658-3.742-21.175-.369-33.619 8.929-40.904 19.417h61.37 21.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m314.507 118.458c-.936-5.528-2.636-10.8-4.989-15.676 13.578-1.956 29.396-3.458 46.658-3.742 21.175-.369 33.619 8.929 40.904 19.417h-61.37-21.203z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresent);
export default __webpack_public_path__ + "static/media/present.b66dcc1bcb0b7f3f1b782768fcbd603e.svg";
export { ForwardRef as ReactComponent };